@if (vm.loading) {
  <app-skeleton-loader class="dark full-width h-40 md-h-32 max-w-120" />
  <app-skeleton-loader class="dark full-width h-40 md-h-32 mt-24 md-mt-16" />
  <app-skeleton-loader class="dark full-width h-40 md-h-32 mt-24 md-mt-16" />
  <app-skeleton-loader class="dark full-width h-40 md-h-32 mt-24 md-mt-16" />
} @else {
  @switch (vm.claimDetails?.panelDisplay) {
    @case ('CREATE_BOOKING') {
      <app-create-booking [claimType]="vm.claimType" [onDownloadPlanDocs]="downloadPlanDocs.bind(this)" />
    }

    @case ('RESUME_BOOKING') {
      <app-resume-booking [claimType]="vm.claimType" />
    }

    @case ('VIEW_PR_OFFER') {
      <app-view-pr-offer [claimType]="vm.claimType" />
    }

    @case ('VIEW_CLAIM') {
      <app-view-claim [claimType]="vm.claimType" />
    }

    @case ('IN_WARRANTY') {
      <app-in-warranty [claimType]="vm.claimType" />
    }

    @case ('RPC') {
      <app-rpc />
    }

    @case ('NOT_FOR_ONLINE') {
      <app-not-for-online [claimType]="vm.claimType" />
    }

    @case ('NO_ALLOCATION_RULES') {
      <app-no-allocation-rules [claimType]="vm.claimType" />
    }

    @case ('ERROR_LOADING_DETAILS') {
      <app-error-loading-details [claimType]="vm.claimType" />
    }

    @case ('IN_WAIT') {
      <app-in-wait [claimType]="vm.claimType" [onDownloadPlanDocs]="downloadPlanDocs.bind(this)" />
    }

    @default {
      <app-unknown [claimType]="vm.claimType" />
    }
  }
}
<!--@if (vm.isLoading) {-->
<!--  @if (vm.showTimeoutMessage) {-->
<!--    <section class="flex flex-row gap-8 mt-32">-->
<!--      <app-loading-spinner variant="blue" [size]="20" />-->
<!--      <p class="body">Sorry, it’s taking longer than usual.</p>-->
<!--    </section>-->
<!--  }-->
<!--  <section class="card-container p-24 md-p-16 mt-16 loading">-->
<!--    <app-skeleton-loader class="full-width h-40 md-h-32 max-w-120" />-->
<!--    <app-skeleton-loader class="full-width h-40 md-h-32 mt-24 md-mt-16" />-->
<!--  </section>-->
<!--} @else if (vm.isError) {-->
<!--  <section class="card-container p-24 md-p-16 mt-32 sm-mt-20">-->
<!--    <section class="flex flex-row gap-8 items-center">-->
<!--      <i class="fa-light fa-circle-exclamation fa-lg" style="color: #aa6804"></i>-->
<!--      <h2 class="heading-3 bold">Your repair</h2>-->
<!--    </section>-->
<!--    <section class="info-box mt-24 p-16">-->
<!--      <p class="body">-->
<!--        We’re having some issues loading your booking. Please-->
<!--        <button type="button" class="link-text pointer" (click)="retry()">check again</button> later, or give us a call-->
<!--        on:-->
<!--      </p>-->
<!--      <app-telephone-link class="mt-8 mb-8 phone" phoneNumber="0333 000 1415"> </app-telephone-link>-->
<!--      <p class="hint">-->
<!--        Calls cost the basic rate per minute plus your phone company’s access charge. From a mobile, they can cost much-->
<!--        more.-->
<!--      </p>-->
<!--    </section>-->
<!--  </section>-->
<!--} @else {-->
<!--  <section class="card-container p-24 md-p-16 mt-32 sm-mt-20">-->
<!--    <h2 class="heading-3 bold">Your repair</h2>-->

<!--    @if (!vm.repairDetails?.repairId || !vm.repairDetails?.appointment) {-->
<!--      <app-non-active-claims [planNumber]="vm.planNumber" />-->
<!--    } @else if (vm.repairDetails) {-->
<!--      <hr class="mt-24 mb-24 md-mt-16 md-mb-16" />-->
<!--      <section class="content flex md-flex-col">-->
<!--        <section class="column flex-col gap-8 md-gap-4">-->
<!--          <h3 class="heading-5">Track your booking</h3>-->

<!--          <p class="body">Reference: {{ vm.repairDetails.claimReference }}</p>-->

<!--          <p class="body">Fault: {{ vm.repairDetails.fault }}</p>-->

<!--          <app-claims-tracker class="mt-8 md-t-12" />-->

<!--          @if (vm.address?.length) {-->
<!--            <hr class="mt-24 mb-24 md-mt-16 md-mb-16" />-->

<!--            <h3 class="heading-5">Address</h3>-->

<!--            <section>-->
<!--              @for (line of vm.address; track line) {-->
<!--                <p class="body">-->
<!--                  {{ line }}-->
<!--                </p>-->
<!--              }-->
<!--            </section>-->
<!--          }-->
<!--        </section>-->

<!--        <div class="divider mr-20 ml-20 md-mr-0 md-ml-0 md-mt-16 md-mb-16"></div>-->
<!--        <section class="column flex-col gap-8">-->
<!--          <h3 class="heading-5">Need an update?</h3>-->

<!--          <p class="body">Please call our repairer if you have any questions or concerns about the repair.</p>-->

<!--          <p class="body mt-4">-->
<!--            {{ vm.formattedProviderName }}-->
<!--          </p>-->

<!--          <app-telephone-link [phoneNumber]="vm.repairDetails.provider?.phoneNumber" />-->

<!--          <app-contact-hours class="mt-4" [contactHours]="vm.repairDetails.provider?.openingHours" />-->

<!--          <p class="hint">-->
<!--            {{ vm.callCostMessaging }}-->
<!--          </p>-->

<!--          <section class="email-link flex gap-8 mt-4">-->
<!--            <i class="fa-light fa-envelope"></i>-->
<!--            <a [href]="'mailto:' + vm.providerEmail" class="link-text">-->
<!--              {{ vm.providerEmail }}-->
<!--            </a>-->
<!--          </section>-->

<!--          <hr class="mt-24 mb-24 md-mt-16 md-mb-16" />-->

<!--          <app-feedback-collection area="repair-tracker" [id]="vm.repairDetails.repairId" [config]="feedbackConfig" />-->
<!--        </section>-->
<!--      </section>-->
<!--    }-->
<!--  </section>-->
<!--}-->
